// Tüm görsel yolları public/ altındaki klasör/dosya isimleriyle eşleşir (küçük harf, tire, boşluksuz).
export const projects = [
  {
    id: 1,
    title: 'ŞB Daire',
    category: 'konut',
    location: 'İstanbul',
    year: '2025',
    status: 'Konsept Tasarım',
    image: '/sam-daire/hero.jpg',
    description: 'Bu konut projesi, dekoratif bir yaklaşım yerine net mekânsal kararlar üzerine kuruldu. Amaç, dikkat çeken bir iç mekân üretmek değil; dili tutarlı, zamana dayanıklı bir yaşam alanı oluşturmaktı.\n\nSalon kurgusunda monoblok bir duvar elemanı ana omurga olarak tasarlandı. Mikrobeton yüzey, geri çekilmiş metal bant ve kontrollü ışık kullanımıyla kütle etkisi güçlendirildi. Malzemeler yarışmadı; birbirini taşıdı.\n\nRenk paleti sade tutuldu. Yüzeyler, hacmi bölmeden derinlik üretmek üzere kurgulandı. Detaylar öne çıkmak için değil, bütünlüğü korumak için tasarlandı.\n\nBu proje, konut tasarımına yaklaşımımızı temsil eder:\nMekânı sadeleştirerek güçlendirmek.\nKararı görünür değil, hissedilir kılmak.',
    images: [
      '/sam-daire/1.jpg',
      '/sam-daire/2.jpg',
      '/sam-daire/3.jpg',
      '/sam-daire/4.jpg',
      '/sam-daire/5.jpg'
    ]
  },
  {
    id: 2,
    title: 'Fulya Ofis',
    category: 'ofis',
    location: 'İstanbul',
    year: '2025',
    image: '/fulya-ofis/final.jpg',
    description: 'Fulya Ofis, sınırlı bir hacimde karar mekânı kurma yaklaşımıdır.\n\nAmaç alanı büyütmek değil, netliği yoğunlaştırmaktır.\n\nMekân, dekoratif katmanlardan arındırılmıştır.\nOperasyonel yük gizlenmiş, kullanıcıya tek bir karar yüzeyi bırakılmıştır.\n\nMasada taşıyıcı sistem zeminde kalır.\nAğır olan ayrıştırılır, yüzey hafifletilir.\nKütleler bilinçli boşluklarla birbirinden koparılır.\n\nMalzeme dili sınırlıdır: traverten, masif ahşap ve metal.\nHer unsur işlevini açıkça taşır.\n\nFulya Ofis, küçük metrekarelerde tavizsiz bir sistem kurulabileceğini gösterir.\nAlan küçülür.\nDüzen yoğunlaşır.\n\nGravitas Libera.',
    images: [
      '/fulya-ofis/1.jpg',
      '/fulya-ofis/2.jpg',
      '/fulya-ofis/3.jpg',
      '/fulya-ofis/4.jpg',
      '/fulya-ofis/5.jpg'
    ]
  },
  {
    id: 3,
    title: 'Zühre Ana Patron Odası',
    category: 'ofis',
    location: 'İstanbul',
    year: '2026',
    image: '/zuhre-ana-patron-odasi/1.jpg',
    description: 'Karaköy\'ün tarihi dokusu içinde modern bir showroom. Beton yüzeyler ve sıcak aydınlatma, ürünlerin öne çıkmasını sağlıyor. Minimalist yaklaşım, ziyaretçi deneyimini merkeze alıyor.',
    images: [
      '/zuhre-ana-patron-odasi/2.jpg',
      '/zuhre-ana-patron-odasi/3.jpg',
      '/zuhre-ana-patron-odasi/4.jpg',
      '/zuhre-ana-patron-odasi/5.jpg',
      '/zuhre-ana-patron-odasi/6.jpg'
    ]
  },
  {
    id: 4,
    title: 'Zühre Ana Genel Merkez Toplantı Odası',
    category: 'ofis',
    location: 'İstanbul',
    year: '2025',
    image: '/zuhre-ana-genel-merkez-toplanti-odasi/hero.jpg',
    description: 'Kurumsal kimliği yansıtan bu ofis alanı, işlevsellik ve estetiği bir araya getiriyor. Açık plan düzen ve özel toplantı alanları, çalışan verimliliğini artıracak şekilde tasarlandı.',
    images: [
      '/zuhre-ana-genel-merkez-toplanti-odasi/1.jpg',
      '/zuhre-ana-genel-merkez-toplanti-odasi/2.jpg',
      '/zuhre-ana-genel-merkez-toplanti-odasi/3.jpg',
      '/zuhre-ana-genel-merkez-toplanti-odasi/4.jpg',
      '/zuhre-ana-genel-merkez-toplanti-odasi/5.jpg'
    ]
  },
  {
    id: 5,
    title: 'Daire Isparta Kule',
    category: 'konut',
    location: 'İstanbul',
    year: '2023',
    image: '/ispartakule/1.png',
    description: 'Geniş yaşam alanlarına sahip bu villa, doğa ile iç mekân arasındaki sınırları bulanıklaştırıyor. Büyük cam yüzeyler, beton ve ahşap malzemelerle uyum içinde. Mekân, sakinlik ve lüksü bir araya getiriyor.',
    images: [
      '/ispartakule/2.png',
      '/ispartakule/3.png',
      '/ispartakule/4.png',
      '/ispartakule/5.png'
    ]
  },
  {
    id: 6,
    title: 'Zühre Ana Showroom',
    category: 'ticari',
    location: 'İstanbul',
    year: '2024',
    image: '/zuhre-ana-showroom/4.jpg',
    description: 'Teknoloji şirketi için tasarlanan bu ofis, açık plan düzen ve esnek çalışma alanları sunuyor. Beton yüzeyler ve modern mobilyalar, yaratıcılığı destekleyen bir ortam yaratıyor.',
    images: [
      '/zuhre-ana-showroom/1.jpg',
      '/zuhre-ana-showroom/2.jpg',
      '/zuhre-ana-showroom/3.jpg',
      '/zuhre-ana-showroom/4.jpg',
      '/zuhre-ana-showroom/5.jpg'
    ]
  },
  {
    id: 7,
    title: 'Gym Sakarya',
    category: 'ticari',
    location: 'İstanbul',
    year: '2022',
    image: '/gym-sakarya/4.jpg',
    description: 'Tarihi Galata bölgesinde modern bir restoran deneyimi. Beton yüzeyler ve sıcak aydınlatma, yemek deneyimini ön plana çıkarıyor. Minimalist yaklaşım, mekânın tarihi dokusuyla uyum içinde.',
    images: [
      '/gym-sakarya/1.jpg',
      '/gym-sakarya/2.jpg',
      '/gym-sakarya/3.jpg',
      '/gym-sakarya/5.jpg',
      '/gym-sakarya/6.jpg'
    ]
  },
  {
    id: 8,
    title: 'Maldivler Hastane',
    category: 'ticari',
    location: 'Maldivler Malé',
    year: '2017',
    image: '/mhastane/1.jpg',
    description: 'Treetop Hospital, Maldivler Malé\'de 2016–2017 yılları arasında hayata geçirilen, çağdaş sağlık mimarisini tropikal iklim koşullarıyla uyumlu bir yaklaşımla ele alan nitelikli bir sağlık yapısıdır. Projede tasarım ve uygulama süreçleri bütüncül bir anlayışla yönetilmiş; fonksiyonel planlama, hasta ve personel sirkülasyonunun net kurgulanması ve yüksek hijyen standartlarının sağlanması temel öncelikler arasında yer almıştır. Doğal ışığın kontrollü kullanımı, ferah iç mekân organizasyonu ve teknik altyapının titizlikle çözülmesi sayesinde hem kullanıcı konforu hem de operasyonel verimlilik üst düzeye çıkarılmıştır. Uluslararası standartlara uygun olarak geliştirilen proje, estetik ve işlevselliği dengeli biçimde bir araya getiren kapsamlı bir sağlık yapısı örneğidir.',
    images: [
      '/mhastane/6.jpg',
      '/mhastane/7.jpg',
      '/mhastane/10.jpg',
      '/mhastane/4.png'
    ]
  },
  {
    id: 20,
    title: 'Maldivler Destek Binası',
    category: 'ticari',
    location: 'Maldivler Malé',
    year: '2017',
    image: '/mdestek/2.jpg',
    description: 'Treetop Hospital kompleksi kapsamında geliştirilen destek binası, Maldivler Malé’de 2016–2017 yılları arasında hayata geçirilen projenin önemli tamamlayıcı yapılarından biridir. Sağlık tesisinin operasyonel ihtiyaçlarını desteklemek amacıyla tasarlanan yapı, konaklama ve hizmet fonksiyonlarını bir araya getirerek hastane personeli ve ziyaretçiler için konforlu bir yaşam ve dinlenme ortamı sunmaktadır.\n\nTropikal iklim koşulları dikkate alınarak geliştirilen mimari yaklaşımda doğal havalandırma, gün ışığının etkin kullanımı ve gölgelendirme elemanları ön plana çıkarılmıştır. Mekânsal organizasyonda kullanıcı konforu, işlevsel planlama ve yapı kompleksinin genel mimari diliyle uyum temel tasarım kriterleri olarak ele alınmıştır.\n\nHastane kampüsünün bütüncül kurgusunu destekleyen proje, fonksiyonel ihtiyaçları karşılayan rasyonel planlama anlayışını, sade ve çağdaş bir mimari ifade ile birleştiren nitelikli bir destek yapısı olarak tasarlanmıştır.',
    images: [
      '/mdestek/12.jpg',
      '/mdestek/13.jpg',
      '/mdestek/14.jpg',
      '/mdestek/15.jpg'
    ]
  },
  {
    id: 9,
    title: 'SD Evi',
    category: 'konut',
    location: 'İstanbul',
    year: '2025',
    image: '/sd-evi/1.png',
    description: 'Sessiz Denge, malzemenin ağırlığını ve ışığın yumuşaklığını aynı mekânda buluşturan zamansız bir konut tasarımıdır. Proje, koyu ahşap yüzeyler, doğal taş dokular ve mat bitişlerle oluşturulan güçlü bir arka plan üzerinde, kontrollü ve sıcak bir aydınlatma kurgusu ile şekillenir. Mekânın temel yaklaşımı; gösterişten uzak, oran ve malzeme kalitesiyle varlık gösteren bir atmosfer yaratmaktır. Tavanlarda kullanılan gizli ışık bantları ve seçilmiş tasarım armatürler, hacmi dramatize etmek yerine mekânın mimari çizgilerini vurgular.',
    images: [
      '/sd-evi/2.png',
      '/sd-evi/3.png',
      '/sd-evi/4.png'
    ]
  },
  {
    id: 11,
    title: 'Cafe Fora',
    category: 'ticari',
    location: 'İstanbul',
    year: '2024',
    image: '/cafe-fora/1.png',
    description: 'Doğal malzemelerin sıcaklığı ile çağdaş çizgilerin dengelendiği bu kafe tasarımında, kullanıcı deneyimi merkeze alındı. Ahşap yüzeyler, taş dokular ve pirinç detaylar bir araya getirilerek zamansız bir atmosfer oluşturuldu. Mekânın odak noktası olan bitkili dairesel aydınlatma, lounge alanını tanımlarken; bar arkasındaki traverten yüzey ve lineer ışık detayları mekâna derinlik ve sofistike bir karakter kazandırıyor. Plan kurgusunda farklı kullanım senaryoları gözetildi: cam kenarında yüksek oturum alanları, merkezi rahat oturma grubu ve bar önü sosyal etkileşim alanı. Gün ışığını maksimum düzeyde içeri alan geniş açıklıklar, iç mekân ile dış çevre arasında güçlü bir ilişki kuruyor. Sonuç olarak ortaya; hem gündüz sakin çalışma buluşmalarına hem de akşam sıcak sosyal deneyimlere uyum sağlayan davetkâr ve güçlü bir kimliğe sahip bir mekân çıktı.',
    images: [
      '/cafe-fora/2.png',
      '/cafe-fora/3.png',
      '/cafe-fora/4.png',
      '/cafe-fora/5.png',
      '/cafe-fora/6.png'
    ]
  },
  {
    id: 12,
    title: 'S Dental Clinic',
    category: 'ticari',
    location: 'İstanbul',
    year: '2024',
    image: '/s-dental-clinic/1.png',
    description: 'S Dental Clinic, sağlık mekânlarında güven ve konfor algısını önceliklendiren zamansız bir iç mekân kurgusuyla tasarlanmıştır. Doğal taş yüzeyler, sıcak ahşap paneller ve gizli aydınlatma detayları birlikte çalışarak sakin, dengeli ve rafine bir atmosfer oluşturur. Resepsiyon alanındaki monolitik banko ve vurgulu logo duvarı mekânın güçlü odak noktasını oluştururken, bekleme alanı ev konforuna yakın bir deneyim sunar. Tedavi odalarında estetik ve hijyen algısı dengeli bir şekilde ele alınmış; doğal tonlar ve gün ışığı destekli aydınlatma ile ferah bir ortam hedeflenmiştir. Proje, fonksiyon ve estetiği sade bir dil içerisinde bir araya getirerek kliniği yüksek kalite algısına sahip, bütüncül bir sağlık deneyimine dönüştürmektedir.',
    images: [
      '/s-dental-clinic/2.png',
      '/s-dental-clinic/3.png',
      '/s-dental-clinic/4.png',
      '/s-dental-clinic/5.png',
      '/s-dental-clinic/6.png'
    ]
  },
  {
    id: 13,
    title: 'Ofis AXIS 1000',
    category: 'ofis',
    location: 'İstanbul',
    year: '2025',
    image: '/ofis-axis-1000/1.png',
    description: 'Axis 1000, 1000 m² büyüklüğünde tasarlanmış bir kurumsal açık ofis konseptidir. Proje, mekânı oda kümeleri olarak değil; işleyişi organize eden bir sistem olarak ele alır. Plan şeması, çalışma alanlarını merkezî bir sirkülasyon ekseni etrafında kurgular. 25–35 kişilik açık çalışma alanı, cam bölmelerle ayrılmış yönetici ofisleri ve toplantı odalarıyla dengelenir. Şeffaflık görsel süreklilik sağlarken, akustik ve mahremiyet kontrollü biçimde çözülür. Malzeme paleti bilinçli olarak sade tutulmuştur: Doğal taş zemin mekâna ağırlık kazandırırken, açık ton ahşap yüzeyler ve mat bitişler sıcaklık üretir. Siyah metal detaylar ve sınırlı pirinç aksanlar kompozisyona disiplin ekler. Geniş sirkülasyon alanları hareketi rahatlatır, sosyal alanlar ise yoğunluk ile mola arasında yumuşak geçişler oluşturur. Bu yaklaşım, ofisi yalnızca çalışma alanı değil; hiyerarşi, etkileşim ve akışın dengelendiği bir organizasyon yapısı olarak tanımlar. Toplam Alan: 1000 m². Program: Açık Çalışma Alanı, Yönetici Ofisleri, Toplantı Odaları, Focus Kabinleri, Sosyal Alan. Durum: Konsept Proje.',
    images: [
      '/ofis-axis-1000/2.png',
      '/ofis-axis-1000/3.png',
      '/ofis-axis-1000/4.png',
      '/ofis-axis-1000/5.png',
      '/ofis-axis-1000/6.png'
    ]
  },
  {
    id: 14,
    title: 'LCW Jeans',
    category: 'ticari',
    location: 'İstanbul',
    year: '2020',
    image: '/lcw-jeans/1.jpg',
    description: 'Bu mağaza tasarımı, endüstriyel strüktürü çağdaş perakende kurgusuyla bir araya getirerek güçlü ve akılda kalıcı bir mekânsal kimlik oluşturuyor. Metal taşıyıcı sistemler, delikli sac paneller ve modüler raf üniteleri mekâna ritim kazandırırken; mavi tonlardaki açık tavan kurgusu ve ray spot aydınlatmalar dinamik bir atmosfer yaratıyor. Ürün sergileme alanları, dolaşımı kesintiye uğratmadan merkezde konumlanan çok işlevli platform etrafında organize edildi. Denim koleksiyonlarının ton geçişleriyle sergilenmesi ve aydınlatmalı görsel panolar, ürünü ön plana çıkaran güçlü bir sahne etkisi sunuyor. Mekânda kullanılan nötr zeminler ve ham dokular, tekstil ürünlerinin renk ve dokusunu vurgularken; grafik yüzeyler ve tavandan sarkan kuş enstalasyonu markaya özgü karakteri destekleyen odak noktaları oluşturuyor. Farklı ürün grupları için oluşturulan net zonlama, kullanıcı deneyimini kolaylaştırırken esnek sergileme sistemleri sayesinde sezonluk dönüşümlere olanak tanıyor. Bu konsept, genç ve enerjik bir marka diliyle fonksiyonelliği dengeli bir biçimde buluşturan çağdaş bir perakende tasarım yaklaşımını yansıtıyor.',
    images: [
      '/lcw-jeans/2.jpg',
      '/lcw-jeans/3.jpg',
      '/lcw-jeans/4.jpg',
      '/lcw-jeans/5.jpg',
      '/lcw-jeans/6.jpg'
    ]
  },
  {
    id: 15,
    title: 'Ritz-Carlton Room',
    category: 'konut',
    location: 'İstanbul',
    year: '2016',
    image: '/ritz-carlton-room/1.png',
    description: 'Bu yatak odası tasarımı, çağdaş lüks anlayışını zamansız detaylarla bir araya getirerek sıcak ve sofistike bir atmosfer oluşturuyor. Yumuşak dokulu yüzeyler, doğal tonlarda seçilmiş duvar kaplamaları ve özenle kurgulanmış gizli aydınlatmalar mekâna derinlik kazandırırken; başlık arkasındaki sanatsal panel güçlü bir odak noktası yaratıyor. Katmanlı ışık senaryosu, günün her saatinde konforlu ve davetkâr bir ambiyans sağlarken, mobilya yerleşimi hem estetik hem işlevsel bir bütünlük sunuyor. Modern çizgiler ile yerel dokunuşların dengeli birlikteliği, kullanıcıya üst düzey bir konaklama deneyimi vadeden rafine bir iç mekân kurgusu ortaya koyuyor.',
    images: [
      '/ritz-carlton-room/2.png',
      '/ritz-carlton-room/3.png',
      '/ritz-carlton-room/4.jpg'
    ]
  },
  {
    id: 16,
    title: 'Ritz-Carlton King Suit',
    category: 'ticari',
    location: 'Ritz Carlton-İstanbul',
    year: '2018',
    image: '/ritz-carlton-king-suit/1.jpg',
    description: 'Ritz Carlton King Suit projesi, lüks otel konaklama deneyimini mekânsal tasarımla bir araya getiren özel bir süit tasarımıdır. Proje durumu: Tamamlandı.',
    images: [
      '/ritz-carlton-king-suit/2.jpg',
      '/ritz-carlton-king-suit/3.jpg',
      '/ritz-carlton-king-suit/4.jpg',
      '/ritz-carlton-king-suit/5.jpg',
      '/ritz-carlton-king-suit/6.jpg'
    ]
  },
  {
    id: 18,
    title: 'LCW IAM Konsept',
    category: 'ticari',
    location: 'İstanbul',
    year: '2021',
    image: '/lcw-iam-konsept/1.jpg',
    description: 'Bu perakende mağaza konsepti, denim odaklı bir marka kimliğini mekânsal deneyime dönüştürmeyi hedefleyen bütüncül bir tasarım yaklaşımıyla ele alınmıştır. Projede; marka dili, müşteri sirkülasyonu, ürün teşhir stratejileri ve aydınlatma kurgusu birlikte değerlendirilerek dinamik, çağdaş ve etkileşimli bir alışveriş atmosferi oluşturulmuştur. Malzeme seçimlerinde sıcak dokular ile endüstriyel detaylar dengelenmiş, neon tipografiler ve grafik yüzeyler aracılığıyla güçlü bir görsel hafıza yaratılmıştır. Modüler sergileme üniteleri ve esnek plan şeması sayesinde farklı koleksiyonlara adapte olabilen bir kurgu geliştirilmiştir. Konsept geliştirme sürecinde aktif rol alınarak, marka hikâyesinin mekâna yansıması, kullanıcı deneyiminin güçlendirilmesi ve satış alanlarının stratejik organizasyonu üzerine tasarım katkısı sağlanmıştır.',
    images: [
      '/lcw-iam-konsept/2.jpg',
      '/lcw-iam-konsept/3.jpg',
      '/lcw-iam-konsept/4.jpg',
      '/lcw-iam-konsept/5.jpg',
      '/lcw-iam-konsept/6.jpg'
    ]
  },
  {
    id: 19,
    title: 'LCW C&P Konsept',
    category: 'ticari',
    location: 'İstanbul',
    year: '2022',
    image: '/lcw-cp-konsept/1.jpg',
    description: 'Bu mağaza konsepti; yalın mimari dil, güçlü ürün teşhiri ve kategori bazlı mekânsal ayrışma prensipleri üzerine kurgulanmıştır. Nötr tonlarda tasarlanan zemin ve duvar yüzeyleri ürünleri ön plana çıkarırken, modüler teşhir elemanları ve merkezi platformlar koleksiyonların net ve okunabilir biçimde sergilenmesini sağlamaktadır. Aydınlatma tasarımında homojen genel ışık ile ürün odaklı vurgu ışıkları dengelenmiş; spor koleksiyon alanlarında kullanılan grafik yüzeyler ve neon detaylar ile dinamik bir atmosfer oluşturulmuştur. Sirkülasyon şeması, kullanıcıyı farklı alt markalar ve tematik bölümler arasında akıcı biçimde yönlendirecek şekilde planlanmıştır. Konsept geliştirme sürecinde aktif katkı sağlanarak; marka kimliğinin mekâna yansıması, teşhir sistemlerinin kurgulanması ve müşteri deneyimini güçlendiren mekânsal organizasyon kararlarının oluşturulmasında rol alınmıştır.',
    images: [
      '/lcw-cp-konsept/2.jpg',
      '/lcw-cp-konsept/3.jpg',
      '/lcw-cp-konsept/4.jpg',
      '/lcw-cp-konsept/5.jpg',
      '/lcw-cp-konsept/6.jpg'
    ]
  },
  {
    id: 10,
    title: 'Ümraniye Daire',
    category: 'konut',
    location: 'İstanbul',
    year: '2023',
    image: '/umraniye-daire/1.jpg',
    description: 'Bu daire projesi, açık plan kurgusu ve dengeli oranlarıyla kompakt bir yaşam alanında maksimum ferahlık üretmeyi hedefler. Salon, mutfak ve yemek alanı tek hacimde bütünleşirken; ada ünitesi mekânsal bir eşik olarak hem işlevsel hem sosyal bir merkez oluşturur. Net sirkülasyon, açık görüş aksları ve gereksiz detaylardan arındırılmış yüzeyler, mekânın sakin ve kontrollü bir karakter kazanmasını sağlar. Açık meşe tonları, kırık beyaz yüzeyler ve doğal dokular sıcak fakat ölçülü bir atmosfer yaratır. Dikey çıtalı duvar ve lineer aydınlatma elemanları hacme ritim kazandırırken, gizli ışık bantları mekânı derinleştirir. Bu proje, küçük metrekareli konutlarda yalınlık ve işlevselliğin birlikte nasıl güçlü bir etki üretebileceğine dair bir tasarım yaklaşımı sunar.',
    images: [
      '/umraniye-daire/2.jpg',
      '/umraniye-daire/3.jpg',
      '/umraniye-daire/4.jpg'
    ]
  }
];